import React from 'react'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

import BroadcastGroupForm from '../components/broadcastGroups/BroadcastGroupForm'
import { useIsSecurityUser } from '../hooks/useIsSecurityUser'

export default function CreateBroadcastGroupPage({ buildingId }) {
  const history = useHistory()
  const isSecurityUser = useIsSecurityUser()

  return (
    <BroadcastGroupForm
      isSecurityUser={isSecurityUser}
      goBack={() => history.push('/comunicaciones')}
      buildingId={buildingId}
    />
  )
}
